import { createModule } from '@vue-storefront/core/lib/module'
import { afterRegistration } from './hooks/afterRegistration'
import { widget } from './store/widget'
import { user } from './store/user'
import { apple } from './store/apple'

const USER_KEY = 'ipay-payment-user'
const WIDGET_KEY = 'ipay-payment-widget'
const APPLE_KEY = 'ipay-payment-apple'

export const IPayPayment = createModule({
  key: 'ipay-payment',
  store: {
    modules: [
      { key: USER_KEY, module: user },
      { key: WIDGET_KEY, module: widget },
      { key: APPLE_KEY, module: apple },
    ]
  },
  afterRegistration
})
